import { render, staticRenderFns } from "./editorialList.vue?vue&type=template&id=064d777c&scoped=true"
import script from "./editorialList.vue?vue&type=script&lang=js"
export * from "./editorialList.vue?vue&type=script&lang=js"
import style0 from "./editorialList.vue?vue&type=style&index=0&id=064d777c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d777c",
  null
  
)

export default component.exports